import {
  createSlice,
  //createEntityAdapter
} from '@reduxjs/toolkit';
import { WorkerShift } from 'types';
import { getDataGantt } from './thunk';

export interface InitialState {
  data?: WorkerShift[];
  loading: boolean;
}

const initialState: InitialState = {
  data: [],
  loading: false,
};

export const supportSiteListGanttSlice = createSlice({
  name: 'supportSiteListGantt-container',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getDataGantt.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDataGantt.fulfilled, (state, { payload }) => {
      state.data = payload.data;
      state.loading = false;
    });
    builder.addCase(getDataGantt.rejected, (state) => {
      state.data = [];
      state.loading = false;
    });
  },
});

// export const {} = supportSiteListGanttSlice.actions;

export default supportSiteListGanttSlice.reducer;
